/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container: ' + container);
      console.log('Variant: ' + variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
  var cart = event.detail.cart;
  if (cart) {    
    // show/hide cart note based on items count

    // if(cart.items.length == 1){
      
    //   document.getElementById("cartNote").style.display = "block";
    // }else{
    //   document.getElementById("cartNote").style.display = "none";

    // }

    // Check if the URL contains "/products/"
    if (window.location.href.includes('/products/')) {

      const path = window.location.pathname;
      if (path.includes('/de')){
         window.location.href = '/de/cart';
      } else if (path.includes('es-de')){
         window.location.href = '/es-de/cart';
      } else{
         window.location.href = '/cart';
      }
      
    }

  }
});


  // Debounced scroll listeners.  Up and down only fire on directions changes
  // These events are useful for creating sticky headers and footers.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
